<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-clipboard mr-2" />Plan Detail</h5>
            <hr />
            <b-row class="mb-3">
                <b-col md="4">
                    No. Plan
                    <h3 class="mb-0">{{ data.head.no }}</h3>
                    <div class="small">{{ $helper.parseDate(data.head.createdAt, true) }}, {{ data.head.createdBy }}</div>
                </b-col>
                <b-col md="4">
                    Status / No. DO
                    <h3 class="mb-0">{{ data.head.status }}</h3>
                    <div class="small text-muted">{{ data.noDo }}</div>
                </b-col>
                <b-col md="4">
                    Tujuan
                    <h3 class="mb-0">{{ data.head.lokasi }}</h3>
                    <div class="small text-muted">{{ data.head.wilayah }}</div>
                </b-col>
            </b-row>
            <b-row class="mb-3">
                <b-col v-if="data.setInstallAt != null" md="4">
                    Set Kirim pada
                    <h4 class="mb-0">{{ $helper.parseDate(data.setInstallAt, true) }}</h4>
                </b-col>
                <b-col v-if="data.setSelesaiAt != null" md="4">
                    Plan Selesai pada
                    <h4 class="mb-0">{{ $helper.parseDate(data.setSelesaiAt, true) }}</h4>
                </b-col>
                <b-col v-if="data.setSelesaiBy != null" md="4">
                    Plan Selesai oleh
                    <h4 class="mb-0">{{ data.setSelesaiBy }}</h4>
                </b-col>
            </b-row>
            <b-row v-if="data.keterangan != null" class="mb-3">
                <b-col>
                    <strong>Keterangan / Tujuan Akhir</strong>
                    <div>{{ data.keterangan }}</div>
                </b-col>
            </b-row>
            <hr />
            <b-row>
                <b-col md="6" sm="12">
                    <h3 class="mb-0">Elektrik & ESP</h3>
                </b-col>
                <b-col md="6" sm="12" class="text-right">
                    <b-button v-if="isModifyAllowed" variant="dark" @click="$bvModal.show('modal-search')">
                        <i class="fa fa-plus mr-2" />Tambah Unit
                    </b-button>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty
                :items="items"
                :fields="fields"
                responsive class="my-3"
            >
                <template v-slot:empty>
                    Tidak ada unit terpilih.
                </template>
                <template v-slot:cell(type)="row">
                    {{ row.item.type }}
                    <div class="small text-muted">{{ row.item.manufacturer }}</div>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge :variant="parseInventoryStatusBadge(row.item.status)">{{ row.item.status }}</b-badge>
                </template>
                <template v-slot:cell(action)="row">
                    <b-button v-if="isModifyAllowed" size="sm" variant="danger" v-b-tooltip.hover.top title="Hapus" @click="openRemoveModal(row.item)">
                        <i class="fa fa-fw fa-times" />
                    </b-button>
                </template>
            </b-table>
            <hr />
            <b-row>
                <b-col md="6" sm="12">
                    <h3 class="mb-0">Engine</h3>
                </b-col>
                <b-col md="6" sm="12" class="text-right">
                    <b-button v-if="isModifyAllowed" variant="dark" @click="$bvModal.show('modal-search-engine')">
                        <i class="fa fa-plus mr-2" />Tambah Engine
                    </b-button>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty
                :items="engines"
                :fields="fieldsEngine"
                responsive class="my-3"
            >
                <template v-slot:empty>
                    Tidak ada engine terpilih.
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge :variant="parseEngineStatusVariantTipe(row.item.status.id)">{{ row.item.status.name }}</b-badge>
                </template>
                <template v-slot:cell(action)="row">
                    <b-button v-if="isModifyAllowed" size="sm" variant="danger" v-b-tooltip.hover.top title="Hapus" @click="openRemoveEngineModal(row.item)">
                        <i class="fa fa-fw fa-times" />
                    </b-button>
                </template>
            </b-table>
            <b-button v-if="isAllowedSetKirim" class="mr-2" variant="primary" @click="$bvModal.show('modal-set-kirim')">
                <i class="fa fa-truck mr-2" /> Set Kirim
            </b-button>
            <b-button v-if="isAllowedSetSelesai" class="mr-2" variant="primary" @click="$bvModal.show('modal-set-selesai')">
                <i class="fa fa-check mr-2" /> Set Selesai
            </b-button>
            <b-button v-if="isAllowedCetakDo" class="mr-2" variant="dark" @click="executePrintDo">
                <i class="fa fa-print mr-2" /> Cetak DO
            </b-button>
            <b-button v-if="isAllowedCancel" variant="danger" @click="$bvModal.show('modal-cancel')">
                <i class="fa fa-times mr-2" /> Batalkan Plan
            </b-button>
        </b-card>
        <b-modal id="modal-search" size="lg" title="Pencarian Unit" hide-footer no-close-on-backdrop no-close-on-esc centered>
            <b-row>
                <b-col md="9">
                    <b-form-input v-model="search.sn" maxlength="100" placeholder="SN" @keydown.enter="searchAndAdd" />
                </b-col>
                <b-col md="3">
                    <b-button variant="primary" block @click="searchAndAdd" :disabled="isSubmitting">
                        {{ isSubmitting ? "Menambahkan..." : "Tambahkan" }}
                    </b-button>
                </b-col>
            </b-row>
        </b-modal>
        <b-modal id="modal-search-engine" size="lg" title="Pencarian Engine" hide-footer no-close-on-backdrop no-close-on-esc centered>
            <b-row>
                <b-col md="9">
                    <b-form-input v-model="search.sn" maxlength="100" placeholder="SN" @keydown.enter="searchAndAddEngine" />
                </b-col>
                <b-col md="3">
                    <b-button variant="primary" block @click="searchAndAddEngine" :disabled="isSubmitting">
                        {{ isSubmitting ? "Menambahkan..." : "Tambahkan" }}
                    </b-button>
                </b-col>
            </b-row>
        </b-modal>
        <b-modal id="modal-set-kirim" title="Konfirmasi Set Kirim" hide-footer no-close-on-backdrop no-close-on-esc centered>
            <div class="mb-3">
                Konfirmasi set kirim untuk plan ini?<br /><br />
                Untuk plan tujuan sumur, semua unit akan berganti lokasi menuju tujuan, dan statusnya berubah menjadi SHIPMENT.<br /><br />
                Untuk plan tujuan warehouse, semua unit akan berganti lokasi menuju tujuan tanpa perubahan status, dan plan langsung dianggap CLOSED.<br /><br />
                DO dapat dicetak setelah melakukan set kirim.
                <!-- <b-form-group class="mt-4" label="Nomor DO">
                    <b-input v-model="input.noDo" maxlength="100" />
                </b-form-group> -->
            </div>
            <div class="text-right">
                <b-button variant="primary" @click="executeSetKirim" :disabled="isSubmitting">
                    {{ isSubmitting ? "Menyimpan..." : "Set Kirim" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-set-selesai" title="Konfirmasi Set Selesai" hide-footer no-close-on-backdrop no-close-on-esc centered>
            <div class="mb-3">
                Konfirmasi set selesai untuk plan ini? Semua unit pada plan ini akan berganti status menjadi INSTALLED, dan plan dinyatakan selesai.
            </div>
            <div class="text-right">
                <b-button variant="primary" @click="executeSetSelesai" :disabled="isSubmitting">
                    {{ isSubmitting ? "Menyimpan..." : "Set Selesai" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-remove" title="Konfirmasi Penghapusan Unit" hide-footer no-close-on-backdrop no-close-on-esc centered>
            <div class="mb-3">
                Hapus {{ activeItem.category }} - {{ activeItem.sn }} dari plan ini?
            </div>
            <div class="text-right">
                <b-button variant="primary" @click="executeRemove" :disabled="isSubmitting">
                    {{ isSubmitting ? "Menghapus..." : "Hapus" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-remove-engine" title="Konfirmasi Penghapusan Engine" hide-footer no-close-on-backdrop no-close-on-esc centered>
            <div class="mb-3">
                Hapus {{ activeEngine.sn }} dari plan ini?
            </div>
            <div class="text-right">
                <b-button variant="primary" @click="executeRemoveEngine" :disabled="isSubmitting">
                    {{ isSubmitting ? "Menghapus..." : "Hapus" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-cancel" title="Konfirmasi Pembatalan Plan" hide-footer no-close-on-backdrop no-close-on-esc centered>
            <b-form-group label="Keterangan Pembatalan">
                <b-input v-model="input.keterangan" maxlength="100" />
            </b-form-group>
            <div class="text-right mt-4">
                <b-button variant="danger" @click="executeCancel" :disabled="isSubmitting">
                    {{ isSubmitting ? "Membatalkan..." : "Batalkan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-do" title="Cetak DO" hide-footer no-close-on-backdrop no-close-on-esc centered>
            <div v-if="isSubmitting">Membuat DO, mohon menunggu...</div>
            <div v-else>
                <a download target="_blank" :href="$BASE_FILE_PATH + pathDo">
                    <b-button variant="primary">
                        <i class="fa fa-fw fa-download mr-2" />Download
                    </b-button>
                </a>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'plan-detail',
    data() {
        return {

            initStatus: 0,
            isSubmitting: false,
            roleId: 1,

            data: {
                head: {}
            },

            input: {
                wilayah: null,
                lokasi: null,
                noDo: "",
                keterangan: ""
            },

            search: {
                sn: "",
                category: null,
            },

            pathDo: "",

            fields: [
                { key: "category", label: "Kategori" },
                { key: "sn", label: "SN" },
                { key: "type", label: "Tipe / Manufaktur" },
                { key: "search1", label: "Info" },
                { key: "status", label: "Status" },
                { key: "action", label: "Aksi"},
            ],

            fieldsEngine: [
                { key: "sn", label: "SN" },
                { key: "type", label: "Tipe" },
                { key: "status", label: "Status" },
                { key: "action", label: "Aksi"},
            ],

            items: [],
            activeItem: {},
            engines: [],
            activeEngine: {},

            optCategory: []

        }
    },
    computed: {

        isAllowedSetKirim() {
            return this.data.head.status == "PERSIAPAN" && [0, 1, 7, 8, 10].includes(this.roleId)
        },

        isAllowedSetSelesai() {
            return this.data.head.status == "INSTALASI" && [0, 2].includes(this.roleId)
        },

        isModifyAllowed() {
            return this.data.head.status == "PERSIAPAN" && [0, 1, 7, 8, 10].includes(this.roleId)
        },

        isAllowedCetakDo() {
            return !["BATAL"].includes(this.data.head.status) && [0, 1, 7, 8, 10].includes(this.roleId)
        },

        isAllowedCancel() {
            return this.data.head.status == "PERSIAPAN" && [0, 1, 7, 8, 10].includes(this.roleId)
        }

    },
    methods: {

        init() {

            this.initStatus = 0

            // let getCategory = this.$axios.get("plan/get-category").then(res => {
            //     this.optCategory = res.data.map(it => { return { value: it.id, text: it.name } })
            // })

            Promise.all([this.getDetail()]).then(res => {
                this.initStatus = 1
            })
            .catch(error => {
                this.$helper.parseError(this, error)
                this.initStatus = -1
            })

        },

        getDetail() {

            return this.$axios.get("plan/" + this.$route.params.id).then(res => {

                this.data = res.data
                this.items = res.data.details
                this.engines = res.data.engines

            })
            .catch(error => this.$helper.parseError(this, error))

        },

        searchAndAdd() {

            this.isSubmitting = true

            let payload = new FormData()
            payload.append("planId", this.$route.params.id)
            // payload.append("categoryId", this.search.category)
            payload.append("sn", this.search.sn)

            this.$axios.post("plan/add", payload).then(res => {

                // Cek apabila sudah ada IDnya
                if(this.items.find(it => it.id == res.data.id && it.category == res.data.category)) {
                    this.$helper.toastError(this, "SN dan kategori ini sudah ada pada daftar unit!")
                }
                else {
                    this.items.push(res.data)
                    this.$bvModal.hide("modal-search")
                    this.search.sn = ""
                    this.$helper.toastSuccess(this, "Berhasil menambahkan unit baru!")
                }

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        searchAndAddEngine() {
            this.isSubmitting = true

            let payload = new FormData()
            payload.append("planId", this.$route.params.id)
            // payload.append("categoryId", this.search.category)
            payload.append("sn", this.search.sn)

            this.$axios.post("plan/add-engine", payload).then(res => {

                // Cek apabila sudah ada IDnya
                if(this.engines.find(it => it.id == res.data.id)) {
                    this.$helper.toastError(this, "SN ini sudah ada pada daftar engine!")
                }
                else {
                    this.engines.push(res.data)
                    this.$bvModal.hide("modal-search-engine")
                    this.search.sn = ""
                    this.$helper.toastSuccess(this, "Berhasil menambahkan engine baru!")
                }

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)
        },

        openRemoveModal(item) {
            this.activeItem = item
            this.$bvModal.show("modal-remove")
        },

        openRemoveEngineModal(engine) {
            this.activeEngine = engine
            this.$bvModal.show("modal-remove-engine")
        },

        executeRemove() {

            this.isSubmitting = true

            let payload = new FormData()
            payload.append("planDetailId", this.activeItem.id)

            this.$axios.post("plan/delete", payload).then(res => {

                let index = this.items.findIndex(it => it.id == this.activeItem.id)
                this.items.splice(index, 1)
                this.$bvModal.hide("modal-remove")
                this.$helper.toastSuccess(this, `Unit ${this.activeItem.category} - ${this.activeItem.sn} berhasil dihapus!`)

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        executeRemoveEngine() {
            this.isSubmitting = true

            let payload = new FormData()
            payload.append("planEngineId", this.activeEngine.id)

            this.$axios.post("plan/delete-engine", payload).then(res => {
                let index = this.engines.findIndex(it => it.id == this.activeEngine.id)
                this.engines.splice(index, 1)
                this.$bvModal.hide("modal-remove-engine")
                this.$helper.toastSuccess(this, `Engine ${this.activeEngine.sn} berhasil dihapus!`)
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)
        },

        openConfirmModal() {

            if(this.input.lokasi == null) {
                return this.$helper.toastError(this, "Mohon memilih tujuan lokasi!")
            }

            if(this.items.length == 0) {
                return this.$helper.toastError(this, "Minimal memilih 1 unit!")
            }

            this.$bvModal.show("modal-confirm")

        },

        executeSetKirim() {

            // if(this.$helper.isBlank(this.input.noDo)) {
            //     return this.$helper.toastError(this, "Nomor DO tidak boleh kosong!")
            // }

            this.isSubmitting = true

            let payload = new FormData()
            payload.append("planId", this.$route.params.id)
            // payload.append("noDo", this.input.noDo)

            this.$axios.post("plan/set-install", payload).then(res => {

                this.$bvModal.hide("modal-set-kirim")
                this.init()
                this.$helper.toastSuccess(this, "Plan berhasil diset kirim!")

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        executeSetSelesai() {

            this.isSubmitting = true

            let payload = new FormData()
            payload.append("planId", this.$route.params.id)

            this.$axios.post("plan/set-selesai", payload).then(res => {

                this.$bvModal.hide("modal-set-selesai")
                this.init()
                this.$helper.toastSuccess(this, "Plan berhasil diset selesai!")

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        executePrintDo() {

            this.$bvModal.show("modal-do")

            this.isSubmitting = true
            this.$axios.get("plan/cetak-do?planId=" + this.$route.params.id).then(res => {
                this.pathDo = res.data
            })
            .catch(error => {
                this.$helper.parseError(this, error)
                this.$bvModal.hide("modal-do")
            })
            .finally(() => this.isSubmitting = false)

        },

        executeCancel() {

            if(this.$helper.isBlank(this.input.keterangan)) {
                return this.$helper.toastError(this, "Mohon mengisi keterangan pembatalan!")
            }

            let payload = new FormData()
            payload.append("planId", this.$route.params.id)
            payload.append("keterangan", this.input.keterangan)

            this.isSubmitting = true
            this.$axios.post("plan/cancel", payload).then(res => {

                this.$bvModal.hide("modal-cancel")
                this.init()
                this.$helper.toastSuccess(this, "Plan berhasil dibatalkan")

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        parseInventoryStatusBadge(status) {

            switch(status) {
                case "READY LINE": return "dark"
                case "RETUR": return "warning"
                case "REPAIR": return "danger"
                case "SHIPMENT": return "primary"
                case "INSTALLED": return "success"
                default: return "light"
            }

        },

        parseEngineStatusVariantTipe(id) {
            switch(id) {
                case 0: return "dark"
                case 1: return "success"
                case 2: return "danger"
                case 3: return "primary"
                case 4: return "warning"
                default: return "light"
            }
        },

    },
    created() {
        this.init()
        this.roleId = this.$helper.getRoleId()
    }
}
</script>
